import React from 'react';
import { Link } from 'react-router-dom';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { checkInstacartRetailer } from 'src/utils/app';
import { useAppSelector } from 'src/utils/Hooks';

const EditBudgetButton = () => {
  const searchParams = useAppSelector((state) => state.app?.queryParams?.searchParams);
  const hashId = useAppSelector((state) => state.entityService.mainEntity?.hashId);
  const isInstacart = checkInstacartRetailer();

  if (isInstacart) {
    return null;
  }

  return (
    <Link to={`/client/${hashId}${searchParams}&tab=advertising&subtab=budgetEntity`}>
      <SlButton variant="contained">Edit Budget</SlButton>
    </Link>
  );
};

export default EditBudgetButton;
